import React from 'react';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import WhyDealersChooseUs from './components/WhyDealersChooseUs';
import Features from './components/Features';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import Cta from './components/Cta';
import Footer from './components/Footer';
import MobileSimulatorPage from './pages/MobileSimulatorPage';
import PricingPage from './pages/PricingPage';
// Ad Creator Pages
import AdCreatorDashboardPage from './pages/AdCreatorDashboardPage'; // Moved to src/pages
import AdEditorPage from './pages/AdEditorPage'; // Moved to src/pages
import './App.css';

function Home() {
  return (
    <>
      <div className="bg-gradient-to-b from-superlist-gradient-green-start to-superlist-gradient-green-end text-white animate-gradient-wave bg-[length:200%_200%]">
        <Hero />
        <WhyDealersChooseUs />
      </div>
      <Features />
      <Process />
      <Testimonials />
      <Cta />
    </>
  );
}

function App() {
  return (
    <div className="app">
      <Helmet>
        <title>LiveFunnel - Automotive Retail Solutions</title>
        <meta
          name="description"
          content="Create high-converting funnels, track performance metrics, and manage customer relationships all in one platform designed specifically for automotive dealerships."
        />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap"
          rel="stylesheet"
        />
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>

      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mobile-simulator" element={<MobileSimulatorPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          {/* Ad Creator Routes */}
          <Route path="/creator" element={<AdCreatorDashboardPage />} />
          <Route path="/creator/editor/:adId" element={<AdEditorPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
